import React from 'react';
import { $FormControl } from './styles';
import { Title as TypographyTitle } from '../newTypography';
export const Title = ({ hideItalic = false, title, }) => {
    return (React.createElement($FormControl, null,
        React.createElement(TypographyTitle, { noMargin: true, type: hideItalic ? undefined : 'title' }, title)));
};
